import React, {useMemo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {SystemSettingsGetSchema} from '../../../../api/DBSchema/SystemSettings';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import EmptyRow from '../../../../components/Simple/EmptyRow';
import Sepperator from '../../../../components/Simple/Sepperator';
import {dateToString} from '../../../../utils/utils';
import SMCButton from '../../../../components/Simple/SMCButton';
import Api from '../../../../api/SMPFetchHelper';
import {ObjectTypes} from '../../../../api/consts';
import {useSMCErrorHandler} from '../../../../utils/errorUtils';
import {useSMCSnackbar} from '../../../../utils/hooks';

const pageSchema = SystemSettingsGetSchema.pages.systemBackupStatus;
const pageId = pageSchema.pageId;

function SystemSettingsSystemBackupStatus({
    systemSettingsObject,
    setSystemSettingsData,
    systemBackupRunNowAction
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();
    const { enqueueErrorSnackbar, enqueueSuccessSnackbar } = useSMCSnackbar();

    const pageData = systemSettingsObject[pageId];

    const isBackupActivated = pageData[pageSchema.isBackupActivated];
    const lastRunDate       = pageData[pageSchema.lastRunDate];
    const state             = pageData[pageSchema.state];
    const errorDetails      = pageData[pageSchema.errorDetails];
    
    const stateValues = pageSchema.stateValues;
    
    const stateString = useMemo(() => {
        switch (state) {
            case stateValues.idle:
                return t('COMMAND_STATE_IDLE');
            case stateValues.waiting:
                return t('COMMAND_STATE_1');
            case stateValues.running:
                return t('COMMAND_STATE_2');
            case stateValues.done:
                return t('COMMAND_STATE_3');
            case stateValues.error:
                return t('COMMAND_STATE_4');
            case stateValues.canceled:
                return t('COMMAND_STATE_5');
            default:
                return null;
        }
    }, [state, stateValues, t]);

    const refreshSystemBackupStatus = useCallback(() => {
        Api.fetchSingleObject(ObjectTypes.SYSTEM_SETTINGS)
            .then(fetchSystemSettingsResp => {
                const systemSettings = fetchSystemSettingsResp.data.data;
                const systemSettingsBackupPage = systemSettings[SystemSettingsGetSchema.pages.systemBackupStatus.pageId];
                setSystemSettingsData(SystemSettingsGetSchema.pages.systemBackupStatus.pageId, systemSettingsBackupPage);
                enqueueSuccessSnackbar(t('OBJECT_EDITOR_OBJ_REFRESHED_OK'));
            })
            .catch(e => {
                const errorMessage = getErrorMessage(e);
                    enqueueErrorSnackbar(errorMessage);
            });
    }, [setSystemSettingsData, getErrorMessage, enqueueErrorSnackbar, enqueueSuccessSnackbar, t]);

    return (
        <EditorLayout>
            {
                isBackupActivated && (
                    <>
                        <SMCTextInput readOnly value={dateToString(lastRunDate)} label={t('SMP.SETTINGS.SYSTEM_BACKUP.STATUS.LAST_RUN')} />
                        <SMCTextInput readOnly value={stateString} label={t('SMP.SETTINGS.SYSTEM_BACKUP.STATUS.STATE')} />
                        {
                            state === stateValues.error && (
                                <SMCTextInput readOnly value={errorDetails} label={t('SMC_GEN_ERROR')} />
                            )
                        }
                        {
                            (state === stateValues.waiting || state === stateValues.running) && (
                                <SMCTextInput readOnly value={errorDetails} label={t('SMC_PROGRESS_HEAD')} />
                            )
                        }
                        {
                            state === stateValues.waiting && (
                                <SMCTextInput readOnly value={errorDetails} label={t('SMC_PROGRESS_HEAD')} />
                            )
                        }
                    </>
                )
            }
            {
                !isBackupActivated && (
                    <SMCLabel bold>{t('SMP.SETTINGS.SYSTEM_BACKUP.STATUS.LINE1')}</SMCLabel>
                )
            }
            <EmptyRow />
            <Sepperator />
            <RowLayout>
                <SMCButton onClick={systemBackupRunNowAction}>{t('SMP.SETTINGS.SYSTEM_BACKUP.STATUS.RUN_NOW')}</SMCButton>
                <SMCButton onClick={refreshSystemBackupStatus} ignoreDisabledContext>{t('SMP.SETTINGS.SYSTEM_BACKUP.STATUS.REFRESH')}</SMCButton>
            </RowLayout>
        </EditorLayout>
    )
}

export default SystemSettingsSystemBackupStatus;